<div class="modal-body">
  <div class="content">
    <div class="content__main">
      <div class="content__main-top">
        <h4 translate>company.overview.generate-update-payment-link.popup.title</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close" aria-hidden="true"></i>
        </button>
      </div>
      <div class="content__main-body">
        <div *ngIf="!paymentLinkError" class="vox-inline-message vox-inline-message_light-grey">
          <div>
            <i class="icon-small-info"></i>
            <span *ngIf="!!generatedLinkData?.generated_link_token"
              [innerHTML]="'company.overview.generate-update-payment-link.popup.link-info-generated' | translate:{ timestamp: generatedLinkData.expires_at | date: 'd.M.y, h:mm a' : undefined : locale}"></span>
            <span *ngIf="!generatedLinkData?.generated_link_token"
              [innerHTML]="'company.overview.generate-update-payment-link.popup.link-info' | translate"></span>
          </div>
        </div>
        <div *ngIf="paymentLinkError" class="vox-inline-message vox-inline-message_light-grey">
          <div>
            <i class="icon-small-alert"></i>
              {{paymentLinkError | translate}}
          </div>
          <button type="button"
            class="vox-btn vox-btn-secondary" (click)="fetchLinkData()"
            translate>company.overview.generate-update-payment-link.popup.button-retry</button>
        </div>
        <ng-container *ngIf="!loading.loadingData">
          <div class="generate__link-block">
            <div *ngIf="!hideGenerateLinkButton" class="generate__link-block--actions">
              <div class="generate__link-block--actions_link" *ngIf="generatedLinkData && generatedLinkData.generated_link_token !== ''">
                <button type="button"
                  class="vox-btn vox-btn-secondary" (click)="copyLink()"
                  translate>company.overview.generate-update-payment-link.popup.button-copy</button>
                <button type="button"
                  class="vox-btn vox-btn-secondary" (click)="openLink()"
                  translate>company.overview.generate-update-payment-link.popup.button-open</button>
              </div>
              <button [ladda]="loading.generateLink" *ngIf="!(generatedLinkData && generatedLinkData.generated_link_token !== '')"
                type="button" class="vox-btn vox-btn-secondary" data-spinner-color="grey" data-style="zoom-in"
                (click)="generateLink()">{{ 'company.overview.generate-update-payment-link.popup.button-generate' | translate }}</button>
            </div>
          </div>
          <div class="send__link-block" *ngIf="generatedLinkData && generatedLinkData.generated_link_token !== ''">
            <label
              class="vox-field-label">{{ 'company.overview.generate-update-payment-link.popup.label' | translate }}</label>
            <div ngbDropdown class="vox-dropdown-input">
              <button class="send__link-dropdown_btn" ngbDropdownToggle>
                {{ selectedEmail }}
              </button>
              <div class="send__link-dropdown_menu" ngbDropdownMenu aria-labelledby="send__link-dropdown">
                <button ngbDropdownItem class="send__link-dropdown_item" type="button" *ngFor="let email of emailList;"
                  (click)="selectEmail(email)">
                  {{ email }}
                </button>
              </div>
            </div>
            <div *ngIf="isManualEntry" class="vox-input-group vox-input-group_dense"
              [ngClass]="{'vox-input-group_invalid': email.invalid && (email.dirty || email.touched)}">
              <input class="vox-text-field" type="email" [formControl]="email"
                [placeholder]="'company.overview.generate-update-payment-link.popup.input-placeholder' | translate" />
              <i class="vox-text-field__icon icon-small-alert"></i>
              <span class="vox-input-group__error-message">
                {{ emailErrorMessage | translate }}
              </span>
            </div>
            <div class="send__link-block--actions">
              <button [ladda]="loading.sendEmail" [disabled]="isManualEntry && email.invalid" type="button"
                class="vox-btn vox-btn-secondary" data-spinner-color="grey" data-style="zoom-in" (click)="onSubmit()">
                {{ 'company.overview.generate-update-payment-link.popup.button-send' | translate }}</button>
            </div>
          </div>
        </ng-container>
        <div *ngIf="loading.loadingData" class="content__main-body--loader">
          <ngx-skeleton-loader [theme]="{'height': '20px', 'width': '100%', 'margin': '0'}"></ngx-skeleton-loader>
          <div class="content__main-body--loader_buttons">
            <ngx-skeleton-loader [theme]="{'height': '40px', 'width': '65px'}"></ngx-skeleton-loader>
            <ngx-skeleton-loader [theme]="{'height': '40px', 'width': '90px', 'margin-left': '10px'}">
            </ngx-skeleton-loader>
          </div>
          <ngx-skeleton-loader [theme]="{'height': '20px', 'width': '100%', 'margin': '0'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{'height': '40px', 'width': '100%', 'margin': '0'}"></ngx-skeleton-loader>
          <div class="content__main-body--loader_buttons">
            <ngx-skeleton-loader [theme]="{'height': '40px', 'width': '65px'}"></ngx-skeleton-loader>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
